import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "~/features/auth/components/route-guard";
import { DashboardSidebar } from "~/features/dashboard/components/dashboard-sidebar";
import { NavHeader } from "~/features/dashboard/components/nav-header";

function DashboardLayout() {
  return (
    <RouteGuard>
      <main
        className="min-h-screen max-h-screen bg-[#FFFFFF] w-full flex justify-between"
        role="main"
        aria-label="Dashboard layout"
      >
        <div className="lg:flex hidden gap-y-6 flex-col h-screen">
          <DashboardSidebar />
        </div>
        <div className="flex-grow w-full pb-0 max-h-screen min-h-screen bg-[#FFFFFF] overflow-y-auto overflow-x-auto hide-scrollbar">
          <NavHeader />
          <div className="container flex-grow w-full"><Outlet /></div>
        </div>
      </main>
      {/* </div> */}
    </RouteGuard>
  );
}

export const Route = createFileRoute("/(dashboard)/dashboard")({
  // beforeLoad: ({ context, location }) => {
  //   if (!context.auth.user) {
  //     throw redirect({
  //       to: '/',
  //       search: {
  //         redirect: location.href,
  //       },
  //     })
  //   }
  // },
  component: DashboardLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Dashboard Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
